import { BRAND } from './brand';

export const env = {
  apiUrl: import.meta.env.VITE_API_URL ?? '',
  appName: import.meta.env.VITE_APP_NAME ?? BRAND.name,
} as const;

/** Normalize VITE_API_URL to include Spring context path when only the API host is set. */
function normalizeApiUrl(configured: string): string {
  const trimmed = configured.replace(/\/$/, '');
  if (!trimmed) {
    return '/api';
  }
  if (trimmed.startsWith('http://') || trimmed.startsWith('https://')) {
    return trimmed.endsWith('/api') ? trimmed : `${trimmed}/api`;
  }
  return trimmed.startsWith('/') ? trimmed : `/${trimmed}`;
}

/** Absolute API base for axios, webhooks, and file URLs (works in browser and Electron file://). */
export function getApiBaseUrl(): string {
  if (import.meta.env.DEV) {
    return '/api';
  }
  const configured = normalizeApiUrl(env.apiUrl);
  if (configured.startsWith('http://') || configured.startsWith('https://')) {
    return configured;
  }
  if (typeof window !== 'undefined') {
    return `${window.location.origin}${configured}`;
  }
  return configured;
}
